import { useState } from 'react';
import { CloudUpload, UploadFile } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, Stack } from '@mui/material';
import { ProductCreateWithVariants } from 'src/app/api/openapi';
import FileUpload from 'src/app/components/FileUpload';
import UploadedFile from 'src/app/components/UploadedFile';
import { FormikErrors } from 'formik';

interface ProductMediaProps {
  product: any;
  setFieldValue?: (
    field: string,
    value: any,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<ProductCreateWithVariants>>;
  viewMode?: boolean;
}

const ProductMedia = ({
  product,
  setFieldValue,
  viewMode,
}: ProductMediaProps) => {
  const [fileUploadModalVisible, setFileUploadModalVisible] = useState(false);

  const handleClose = () => {
    setFileUploadModalVisible(false);
  };

  return (
    <>
      <Stack direction="row" flexWrap="nowrap" overflow="hidden">
        {product.media?.images?.map((image: any) => (
          <Box
            component="img"
            src={image.url}
            key={image.url}
            alt="alt text here"
            loading="lazy"
            height={150}
            mr={1}
            borderRadius={1}
          />
        ))}
        {product.filesToUpload?.map((file: File) => (
          <>
            <Box
              component="img"
              src={URL.createObjectURL(file)}
              key={file.name}
              alt="alt text here"
              loading="lazy"
              height={150}
              mr={1}
              borderRadius={1}
            />
            <UploadFile sx={{ position: 'relative', right: '30px' }} />
          </>
        ))}
      </Stack>
      {!viewMode ? (
        <Button
          component="label"
          role={undefined}
          variant="flat"
          tabIndex={-1}
          startIcon={<CloudUpload />}
          onClick={() => setFileUploadModalVisible(true)}
        >
          Upload images
        </Button>
      ) : null}
      <Dialog open={fileUploadModalVisible} onClose={handleClose}>
        <Box sx={{ m: 4 }}>
          <FileUpload
            onDropAccepted={(files: File[]) => {
              setFieldValue && setFieldValue('filesToUpload', files);
            }}
          />
          {product.filesToUpload?.map((file: File) => (
            <UploadedFile
              key={file.name}
              file={file}
              uploaded={false}
              isUploading={false}
              error={undefined} // todo
              onClear={() => {
                // todo remove only one file
                setFieldValue && setFieldValue('filesToUpload', []);
              }}
            />
          ))}
        </Box>
        <DialogActions>
          <Button
            variant="flat"
            disabled={product.filesToUpload?.length <= 0}
            onClick={handleClose}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProductMedia;
